import { createFormHook, createFormHookContexts } from "@tanstack/react-form";
import { EmailField } from "./email-field";
import { NumberField } from "./number-field";
import { PasswordField } from "./password-field";
import { SubmitButton } from "./submit-button";
import { TextField } from "./text-field";

export const { fieldContext, useFieldContext, formContext, useFormContext } =
	createFormHookContexts();

export const { useAppForm } = createFormHook({
	fieldContext,
	formContext,
	fieldComponents: {
		TextField,
		PasswordField,
		NumberField,
		EmailField,
	},
	formComponents: {
		SubmitButton,
	},
});
